import React from 'react';
import Tooltip from '@mui/material/Tooltip';

interface ButtonActionProps {
    onClick: () => void;
    icon: React.ReactNode | string;
    disabled?: boolean;
    color?: 'blue' | 'red' | 'gray' | string;
    title?: string;
}

const ButtonAction: React.FC<ButtonActionProps> = ({
    onClick,
    icon,
    color = 'gray',
    disabled = false,
    title,
}) => {
    const colorMap: Record<string, string> = {
        blue: 'text-blue-600 hover:underline',
        red: 'text-red-600 hover:underline',
        gray: 'text-gray-600 hover:underline',
    };

    return (
        <Tooltip title={title} arrow placement="top">
            <span>
                <button
                    disabled={disabled}
                    className={`${colorMap[color]} flex items-center justify-center w-8 h-8 rounded-full focus:outline-none ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    onClick={onClick}
                    type="button"
                >
                    {icon}
                </button>
            </span>
        </Tooltip>
    );
};

export default ButtonAction;
